import { includesRequiredQueryParams } from '@src/utils/request';
import { RouteConfig } from 'vue-router';

/* eslint-disable @typescript-eslint/explicit-function-return-type */
const microFeedbackRoutes: Array<RouteConfig> = [
	{
		path: '/micro-feedback',
		name: 'micro-feedback',
		beforeEnter: async (to, from, next) => {
			const includesRequiredParams = includesRequiredQueryParams(['eventType', 'associatedEventId'], to);
			if (includesRequiredParams) {
				next();
			} else {
				next({ name: 'account-overview', replace: true });
			}
		},
		component: () => import(/* webpackChunkName: "micro-feedback" */ '@views/micro-feedback/micro-feedback.vue'),
		redirect: { name: 'micro-feedback-satisfaction-form' },
		children: [
			{
				path: 'satisfaction-feedback',
				name: 'micro-feedback-satisfaction-form',
				component: () =>
					import(
						/* webpackChunkName: "micro-feedback-satisfaction-form" */ '@views/micro-feedback/micro-feedback-satisfaction-form.vue'
					)
			},
			{
				path: 'success',
				name: 'micro-feedback-success',
				component: () =>
					import(
						/* webpackChunkName: "micro-feedback-success" */ '@views/micro-feedback/micro-feedback-success.vue'
					)
			}
		]
	}
];
export default microFeedbackRoutes;
